import React, { useState, useMemo, useCallback, useEffect, useRef, Fragment } from 'react';
import './top-navbar.less';
import { Col, Button, Row, Dropdown, Menu, Modal, Tooltip, notification } from 'antd';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import { MenuInfo } from 'rc-menu/lib/interface';
// import powered_logo from './imgs/powered_by_ws.svg';
import { worker_fetch } from './worker-fetch';
import Cookies from 'universal-cookie';
import ensaas_logo from './imgs/ensaas-logo.svg';
import { datacenter_url, datacenter, props_type, env_type, service_type, log_out_type } from './interface';
import { web_worker } from './webworker';
import { useDeepCompareEffect, useDeepCompareMemo } from 'use-deep-compare';
import { LOGIN_URL } from '../../pages/login/login-util';
import { SSO } from '../../shared-functions/constants/login';
import { DATACENTER_NAME, LANG, PAGE_PATH, V1 } from './constants';

export const set_lang_cookie = (language: string): void => {
  const domain =
    /* 檢查是否為IP */ /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
      window.location.hostname
    ) || /* 檢查是否為localhost*/ window.location.hostname === 'localhost'
      ? window.location.hostname
      : window.location.hostname.replace(/(.*?)\./, '.');

  new Cookies().set(LANG, language, { domain: domain, path: '/', maxAge: 31536000 });
};

const get_env = (props: props_type, datacenter_name: string | undefined) => {
  return new Promise(async (resolve: (value: unknown) => void) => {
    type env_new_type = { [key: string]: env_type };
    const env_new: service_type | undefined = (
      (await worker_fetch({
        url: `${props?.is_ecm ? '/v1' : props?.api_proxy_path?.ecm ? `/${props?.api_proxy_path.ecm}` : ''}/services`,
        formatMessage: undefined,
        history: props?.history
      })) as any
    )?.data.items;

    try {
      if (env_new?.[0]) {
        web_worker(
          ({ env_new }: { env_new: service_type[] }) => {
            let env_new_new: env_new_type = {};
            env_new?.forEach((env) => {
              Object.entries(env)?.forEach((item: any) => {
                let key: string, value: { [key: string]: env_type };
                key = item?.[0];
                value = item?.[1];
                if (!key) {
                  return;
                }
                env_new_new[key] = (() => {
                  const env_internal = Object.values(value)?.[0];
                  env_internal.externalUrl = env_internal?.externalAddress;
                  env_internal.internalUrl = env_internal?.internalAddress;
                  delete env_internal.externalAddress;
                  delete env_internal.internalAddress;
                  return env_internal;
                })();
              });
            });
            return JSON.stringify(env_new_new);
          },
          {
            env_new
          },
          resolve
        );
      } else
        resolve(
          (((await (await fetch(`/${props?.api_proxy_path?.listing ? `${props?.api_proxy_path?.listing}/` : ''}datacenter?datacenterCode=${datacenter_name || sessionStorage.getItem(DATACENTER_NAME) || ''}`))?.json()) as datacenter)
            ?.data || [])[0]?.datacenterUrl
        );
    } catch (e) {
      console.error(e);
    }
  });
};

export const log_out: log_out_type = async ({ props, env, history, redirect_url, custom_log_out_path, datacenter_name, logout_body, login_path }): Promise<void> => {
  const { hostname } = window.location;
  if (!env) get_env(props, datacenter_name);
  const { origin }: Location = window.location;
  let try_datacenter_url: any = '';
  try {
    try_datacenter_url = ((await (await fetch(`/datacenter`))?.json()) as datacenter)?.data?.find(({ datacenterUrl }) =>
      datacenterUrl?.['portal-catalog']?.externalUrl?.includes(hostname.substr(hostname.indexOf('.')))
    )?.datacenterUrl?.['portal-catalog']?.externalUrl;
  } catch (err) {
    console.error(err);
  } finally {
    const catalog_url: string = history
      ? ''
      : env?.['portal-catalog']?.externalUrl ||
        sessionStorage.getItem('catalog_url') ||
        try_datacenter_url ||
        origin.replace(origin.split('-')[1], 'catalog').replace(/:[1-9].*/, '');
    sessionStorage.clear();
    const logout = await fetch(custom_log_out_path ? custom_log_out_path : '/v4.0/auth', { method: 'DELETE', body: logout_body });
    logout &&
      (history
        // ? redirect_url && history.push(redirect_url)
        ? redirect_url && window.open(redirect_url, '_self')
        : window.location.replace(
            `${catalog_url}/${login_path || 'login'}${redirect_url}`
          ));
  }
};

const TopNavbar: React.FC<props_type> = (props: props_type) => {
  const [visible, set_visible]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
    {
      lang,
      portal_name,
      is_lite,
      hide_left_menu_button,
      user_name,
      show_addUser,
      api_proxy_path,
      redirect_url,
      is_ecm,
      set_lang,
      set_datacenter_name,
      set_env,
      set_fly_in,
      custom_elements,
      custom_buttons,
      custom_menu_items,
      custom_menu_item_click,
      custom_menu_selected,
      theme,
      is_mp,
      login_path,
      hide_welcome,
      no_console,
      do_not_check_license,
      custom_log_out_path,
      portal_logo,
      hide_subtitle,
      intl,
      set_login_in_sign,
      logout_body,
      show_ticket,
      setting_params,
      is_sso
    }: props_type = useMemo((): any => props, [props]),
    [env_local, set_env_local]: [datacenter_url | undefined, React.Dispatch<React.SetStateAction<datacenter_url | undefined>>] =
      useState<datacenter_url | undefined>(),
    [lang_local, set_lang_local]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(lang),
    [datacenter_name_local, set_datacenter_name_local]: [string | undefined, React.Dispatch<React.SetStateAction<string | undefined>>] =
      useState<string | undefined>(),
    path = useMemo(() => props.history.location.pathname, [props]),
    history = useMemo(() => props.history, [props.history]),
    is_not_login = useMemo(() => !path.includes(login_path || PAGE_PATH.LOGIN), [path, login_path]),
    is_not_license = useMemo(() => !path.includes('license'), [path]),
    // [license, set_license]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>(),
    license_path = useMemo(
      () =>
        typeof props.license_path === 'string' ? (props.license_path.startsWith('/') ? props.license_path : `/${props.license_path}`) : `${V1}license/info`,
      [props.license_path]
    );
  const [already_warn, set_already_warn] = useState(false);
  const [no_console_list, set_no_console_list]: [string[], React.Dispatch<React.SetStateAction<string[]>>] = useState<string[]>([]);

  useEffect(() => {
    !!show_ticket &&
    (
      async () => {
        const auth: any = await worker_fetch({url: `/${api_proxy_path?.sso ? api_proxy_path?.sso: 'v4.0'}/users/me/info`, history});
        if (auth?.data?.id) {
          const role =  auth.data.ssoRole, userEnterprises = auth.data.userEnterprises,
            datacenter_selected = datacenter_name_local || sessionStorage.getItem(DATACENTER_NAME);
            const ticketStatus = show_ticket?.({role, datacenter_selected, userEnterprises});
            !ticketStatus && set_no_console_list((item: string[]) => ([...item, 'ticket_portal']));
        }
      }
    )()
  }, [datacenter_name_local, history, api_proxy_path, show_ticket])

  const menu: JSX.Element = useDeepCompareMemo(
      () => (
        // @ts-ignore
        <Menu className='theme' onClick={custom_menu_item_click} selectedKeys={custom_menu_selected}>
          {is_not_login && [
            user_name && !hide_welcome && (
              <Menu.Item key='hi'>
                <FormattedMessage id='hi' />
                {user_name?.includes('@') ? user_name?.substr(0, user_name?.indexOf('@')) : user_name}
              </Menu.Item>
            ),
            custom_menu_items,
            <Menu.Item
              key={`${user_name ? 'log_out' : 'log_in'}`}
              onClick={() => {
                set_login_in_sign?.(true);
                log_out({
                  props,
                  history: redirect_url ? props.history : undefined,
                  redirect_url,
                  custom_log_out_path,
                  datacenter_name: datacenter_name_local,
                  logout_body,
                  login_path
                });
              }}
            >
              <FormattedMessage id={`${user_name ? 'log_out' : 'log_in'}`} />
            </Menu.Item>
          ]}
        </Menu>
      ),
      [
        is_not_login,
        custom_menu_items,
        redirect_url,
        user_name,
        custom_menu_item_click,
        is_ecm,
        show_addUser,
        hide_welcome,
        custom_log_out_path,
        datacenter_name_local,
        props
      ]
    ),
    change_lang = useCallback(
      ({ key }: MenuInfo) => {
        if (typeof key === 'string') {
          set_lang_local(key);
          set_lang_cookie(key);
          // is_reload && window.location.reload();
        }
      },
      [set_lang_local]
    ),
    langs_menu: JSX.Element = useMemo(
      () => (
        <Menu
          selectedKeys={[lang]}
          // @ts-ignore
          onClick={(e: MenuInfo) => {
            change_lang(e);
          }}
        >
          <Menu.Item key='en-US'>English(US)</Menu.Item>
          <Menu.Item key='zh-CN'>简体中文</Menu.Item>
          <Menu.Item key='zh-TW'>繁體中文</Menu.Item>
          {/* <Menu.Item key="ja-JP">日本語</Menu.Item> */}
        </Menu>
      ),
      [change_lang, lang]
    ),
    portals_common: React.MutableRefObject<{ name: string; key: string }[]> = useRef([
      // { name: 'management_portal', key: 'mp' },
      { name: 'user_center', key: SSO },
      { name: 'service_portal', key: 'service' }
    ]),
    portals_public_cloud = useRef([
      { name: 'billing_portal', key: 'bill' },
      { name: 'ticket_portal', key: 'ticket' }
    ]),
    portal_menu: JSX.Element = useMemo(
      () => (
        <Menu
          // @ts-ignore
          onClick={(e: MenuInfo) => {
            const is_service = e.key === 'service';
            const key = is_service ? 'mp' : e.key;
            const service_path = is_service ? '/instance-list' : '';
            const datacenter = datacenter_name_local || sessionStorage.getItem(DATACENTER_NAME) || '';
            // ticket只有一个地址 https://portal-support-ensaas.sa.wise-paas.com，从其他portal跳转到ticket需要直接跳转到login页面并且携带站点，若EIToken有效，会直接跳转到首页
            // const externalUrl = ((env_local as unknown as { [key: string]: { externalUrl: string; internalUrl: string } }) || {})[`portal-${key}`]?.externalUrl;
            const defaultUrl = key === 'ticket' ? origin.replace(origin.split('-')[1], 'wisepaas').replace(/:[1-9].*/, '') +'/ticket/my-ticket' : origin.replace(origin.split('-')[1], `${key}`).replace(/:[1-9].*/, '');
            const externalUrl = ((env_local as unknown as { [key: string]: { externalUrl: string; internalUrl: string } }) || {})[`portal-${key}`]?.externalUrl || defaultUrl;
            is_mp && key === 'mp' ? history.push('/instance-list') : externalUrl ? window.open(externalUrl + service_path, '_blank'):
              (key !== 'ticket' ? window.open(origin.replace(origin.split('-')[1], (key as string)).replace(/:[1-9].*/, '') + service_path, '_blank'):
                window.open(datacenter === 'bj' ? 'https://www.wise-paas.cn/ticket/create-ticket': `https://portal-support-ensaas.sa.wise-paas.com/web/login.html?datacenter=${datacenter}`, '_blank'));
          }}
        >
          {[...(is_sso ? portals_common?.current?.filter((c: any) => c?.name !== 'user_center') : portals_common?.current),
            ...(!is_lite ? portals_public_cloud.current : [])]
            .filter(({ name }: { name: string; key: string }) => !no_console_list?.includes(name))
            .filter(({ name }: { name: string; key: string }) => {
              if (is_lite) {
                return name !== portal_name && name !== 'service_portal';
              }
              return name !== portal_name;
            })
            .map(({ name, key }: { name: string; key: string }) => (
              <Menu.Item key={key}>
                <Tooltip placement='left' title={<FormattedMessage id={`${key}_desc`}></FormattedMessage>}>
                  <span>
                    <FormattedMessage id={name} />
                  </span>
                </Tooltip>
              </Menu.Item>
            ))}
        </Menu>
      ),
      [env_local, portal_name, is_lite, is_mp, history, no_console_list, datacenter_name_local, is_sso]
    );

  useEffect((): void => {
    set_lang && set_lang(lang_local);
  }, [lang_local, set_lang]);

  useDeepCompareEffect((): void => {
    let init_lang = new Cookies().get(LANG);
    if (set_lang) {
      if (!init_lang) {
        init_lang = ['zh-CN', 'zh-TW', 'en-US'].includes(navigator.language) ? navigator.language : 'en-US';
      }
      set_lang(init_lang);
      set_lang_cookie(init_lang);
      set_lang_local(init_lang);
    }
  }, [set_lang]);

  useDeepCompareEffect((): void => {
    (async (): Promise<void> => {
      const env_new = (await get_env(props, datacenter_name_local)) as { [key: string]: env_type };
      props.set_env?.(env_new);
      set_env_local(env_new);
      sessionStorage.setItem(
        'catalog_url',
        env_new?.['portal-catalog']?.externalUrl || origin.replace(origin.split('-')[1], 'catalog').replace(/:[1-9].*/, '')
      );
    })();
  }, [set_env, history, is_ecm, api_proxy_path?.ecm]);

  useDeepCompareEffect((): void => {
    (async (): Promise<void> => {
      const datacenter_name_session = sessionStorage.getItem(DATACENTER_NAME),
        datacenter_name_new: string | undefined =
          datacenter_name_session ||
          (
            (await worker_fetch({
              url: `${is_mp ? '/v1' : api_proxy_path?.mp ? `/${api_proxy_path.mp}` : ''}/datacentercode`,
              formatMessage: undefined,
              history
            })) as any
          ).data?.datacenterCode;
      if (datacenter_name_new) {
        if (datacenter_name_session !== datacenter_name_new) sessionStorage.setItem(DATACENTER_NAME, datacenter_name_new);
        set_datacenter_name && set_datacenter_name(datacenter_name_new);
        set_datacenter_name_local(datacenter_name_new);
      }
    })();
  }, [set_datacenter_name, set_env, history, is_mp, api_proxy_path?.mp]);

  useEffect(() => {
    (async () => {
      if (license_path && !path.includes('license') && !do_not_check_license) {
        const res: any = await worker_fetch({ url: license_path, history });
        const license = res.data;
        if (Array.isArray(license)) {
          const basicLicense: any = license.find((item: any) => item.type === 'Basic');
          const invalid_day: string = String(14 - basicLicense?.inactiveDays);
          ((
            {
              Inactive: () => {
                if (!already_warn) {
                  notification.warning({
                    message: intl.formatMessage({ id: 'warning' }),
                    description:
                      invalid_day === '0'
                        ? intl.formatMessage({ id: 'license_invalid_immediately' })
                        : intl.formatMessage({ id: 'license_invalid_after' }) + invalid_day + intl.formatMessage({ id: 'n_days' }),
                    duration: 0
                  });
                  set_already_warn(true);
                }
              },
              Invalid: () => {
                history.push({ pathname: LOGIN_URL.licenseInvalid });
              }
            } as { [key: string]: (() => void) | undefined }
          )[basicLicense?.licenseStatus]?.());
        }
      }
    })();
    // eslint-disable-next-line
  }, [license_path, path, history, already_warn, do_not_check_license]);

  return (
    <Fragment>
      <Modal
        width={660}
        title={<FormattedMessage id='contact_technical_support' />}
        visible={visible}
        onCancel={() => {
          set_visible(false);
        }}
        destroyOnClose={true}
        footer={null}
      >
        <FormattedMessage id='support_message' />
        <a href='mailto:WISE-PaaS.SRE@advantech.com'>&nbsp;WISE-PaaS.SRE@advantech.com</a>
      </Modal>
      <Row className='app-header login-header-box' align='middle' justify='space-between'>
        <Row className="bd-linear"></Row>
        <Col className='left_width'>
          <Row align='middle' className='left_elements'>
            {is_not_login && !hide_left_menu_button && (
              <Button
                onClick={() => {
                  set_fly_in?.((current_state: 1 | undefined) => (current_state ? undefined : 1));
                }}
                className={`header_list_btn_${theme} ml-28 btn-drawer`}
              >
                <div className="header-drawer"></div>
              </Button>
            )}
            <img
              src={setting_params?.loginPageTopLogo || portal_logo?.logo || ensaas_logo}
              alt={'logo'}
              style={portal_logo?.style ? portal_logo.style : {}}
              className={`logo ${portal_logo ? '' : 'ensaas_logo'} ml-${is_not_login ? (hide_left_menu_button ? '28' : '') : '30'}${
                is_lite ? '' : ' pointer'
              }${is_not_login ? '' : ' d-inline'}`}
              onClick={() => {
                const { origin }: Location = window.location;
                const portal_catalog_url = origin.replace(origin.split('-')[1], 'catalog').replace(/:[1-9].*/, '');
                !is_lite &&
                  (env_local?.['portal-catalog']?.externalUrl
                    ? window.open(env_local['portal-catalog']?.externalUrl, '_blank')
                    : window.open(portal_catalog_url, '_blank'));
              }}
            />
            {/* {setting_params?.loginPageTopLogo && (
              <img
                src={setting_params.loginPageTopLogo}
                alt="loginPageTopLogo"
                style={{ width: 300, height: 48 }}
              />
            )} */}
            {!hide_subtitle &&
              portal_name &&
              (is_not_login ? (
                <Col className={`${is_mp ? 'portal_name_mp' : ''} portal_name d-flex align-items-center`}>
                  <FormattedMessage id={portal_name} />
                </Col>
              ) : (
                <Col className={`${is_mp ? 'portal_name_mp_login' : ''} portal_name d-flex align-items-center`}>
                  <FormattedMessage id={portal_name} />
                </Col>
              ))}
            {custom_elements}
          </Row>
        </Col>
        <Col className='top-navbar-buttons d-flex justify-end'>
          {
            !no_console && is_not_login && !setting_params?.disableUserMeCallMp &&
            <Col style={{margin: '0 12px'}} className="line-console"></Col>
          }
          {!no_console && is_not_login && !setting_params?.disableUserMeCallMp && (
            <>
              <Col className='nav_button d-flex justify-center'>
                <Dropdown className='ant-col p-0' overlay={portal_menu} trigger={['click']} placement={'bottomCenter'}>
                  <Button className={`ant-col ant-col-sm-24 console_button p-0 header_btn_color_${theme}`}>
                    <Col className='button_label'>
                      <FormattedMessage id='top_console' />
                    </Col>
                    <div className="nav-icon arrowdown-icon"></div>
                  </Button>
                </Dropdown>
              </Col>
            </>
          )}
          {/* {!no_datacentercode && (
            <Col className='nav_button d-flex justify-center'>
              <Button className={`ant-col ant-col-sm-24 location-button p-0 text-center header_btn_color_${theme}`} disabled>
                <EnvironmentFilled />
                <Col className='button_label'>{datacenter_name_local?.toLocaleUpperCase() || 'N/A'}</Col>
              </Button>
            </Col>
          )} */}
          <Col style={{margin: '0 12px'}} className="line-console"></Col>
          {custom_buttons &&
            custom_buttons?.map((custom_element: JSX.Element, index: number) => (
              <Col className='nav_button d-flex justify-center' key={index}>
                {custom_element}
              </Col>
            ))
          }
          <Col className='nav_button d-flex justify-center'>
            <Dropdown className='ant-col p-0' overlay={langs_menu} trigger={['click']} placement={'bottomCenter'}>
              <Button className={`lang-button ant-col-sm-24 header_btn_color_${theme}`}>
                {/* <div className='button_label'>{lang === 'en-US' ? 'En' : lang === 'zh-CN'? '简中': '繁中'}</div> */}
                {/* <div className="nav-icon arrowdown-icon"></div> */}
                <div className="nav-icon lang-icon"></div>
              </Button>
            </Dropdown>
          </Col>
          {is_not_login && is_not_license &&
          <>
            <Col className='nav_button d-flex justify-center'>
              <Dropdown className='ant-col p-0' overlay={menu} trigger={['click']}>
                <Button className={`ant-col-sm-24 header_btn_color_${theme} user_admin`}>
                  {/* <img src={user_admin} alt='user' />
                  {user_name ? <Badge status='success' /> : <Badge color='#9E9E9E' />} */}
                  {
                    !user_name ? <div className="nav-icon user-icon"></div>:
                      <div className="has-user">
                        {
                          (user_name?.includes('@') ? user_name?.substr(0, user_name?.indexOf('@')) : user_name)?.substr(0, 1)?.toLocaleUpperCase()
                        }
                      </div>
                  }
                </Button>
              </Dropdown>
            </Col>
          </>}
          {/* <Col className='powered_logo'>
            <img src={powered_logo} alt='Powered By WISE PaaS' />
          </Col> */}
        </Col>
      </Row>
    </Fragment>
  );
};

export default withRouter(injectIntl(TopNavbar));
